import $store from "../store";
import $router from "../router";

class UiPlugin {
  constructor(Vue) {
    this._vm = Vue;
  }

  notify(notification) {
    $store.commit("ui/notify", notification);
  }

  showError(err) {
    console.error(err);

    if (err.response && err.response.data) {
      // console.log('ERROR', err.response.data)
      let r = err.response.data;
      if (r.code === 401) {
        $router.push({ name: "login" });
      }
      this.notify({
        type: "danger",
        title: "ERRORE",
        message: r.message,
      });
    }
  }

  showEcMessaggio() {
    this.notify({
      type: "warning",
      title: "ATTENZIONE",
      message:
        "Si avverte che il saldo contabile per le ultime annualità potrebbe essere soggetto a variazioni, in conseguenza del perfezionamento dei procedimenti di adeguamento canone e relativa ricostruzione sulle componenti canoni e oneri accessori.",
    });
  }

  showEcMessaggioInvalid() {
    this.notify({
      type: "danger",
      title: "ATTENZIONE",
      message:
        "Estratto Conto non visualizzabile. Contattare gli sportelli Aequaroma.",
    });
  }

  showEcMessaggioDataFiltered(dataInvalida) {
    this.notify({
      type: "warning",
      title: "ATTENZIONE",
      message:
        "L’estratto conto riporta i documenti emessi e relativi pagamenti a partire dal " +
        dataInvalida +
        ". Per il periodo precedente sono in corso verifiche amministrative, al cui completamento si potrà consultare l’intera posizione contabile. Si avverte che il saldo contabile per le ultime annualità potrebbe essere soggetto a variazioni, in conseguenza del perfezionamento dei procedimenti di adeguamento canone e relativa ricostruzione sulle componenti canoni e oneri accessori.",
    });
  }
}

export default {
  install(Vue, options) {
    Vue.prototype.$ui = new UiPlugin(Vue, options);
  },
};
